import { createContext, useContext } from 'react';
import type { BookingStore } from './stores/booking';

// Not a module-level singleton: the server renders many visitors' pages in one
// process, so each page creates its own store and hands it down from here.
const BookingStoreContext = createContext<BookingStore | null>(null);

export const BookingStoreProvider = BookingStoreContext.Provider;

/** The product page's BookingStore, from the nearest BookingStoreProvider. */
export function useBookingStore(): BookingStore {
  const store = useContext(BookingStoreContext);
  if (!store) {
    throw new Error('useBookingStore must be used inside BookingStoreProvider');
  }
  return store;
}
